export interface TFavoritesActivity {
  asking_discount?: number
  asking_price: number
  asking_price_per_carat?: number
  category_id: number
  company_id: number
  company_title: string
  consignor_name: string
  consignor_payout_amount: number
  cost: string
  count_of_bids: number
  count_of_unique_user_views: number
  count_of_wishlists: number
  email: string
  high_bid: number
  item_id: number
  list_price: number
  resolved: boolean
  sales_target: number
  sales_target_per_carat?: number
  shipping_owner: string
  stock_number: string
  title: string
  user_id: number
  weight?: number
  winning_bid: number
  buy_bid?: number
}

export interface TFavoritesActivityChild {
  company_id: number
  company_title: string
  count_views: number
  disable_email_notifications: boolean
  disabled: boolean
  email: string
  first_name: string
  full_access_categories: number[]
  last_name: string
  last_signed_in: string
  message_method_id: number
  message_title: string
  role_id: number
  source: string
  user_id: number
  view_only_categories: number[]
  worthy_buyer_id: number
  wishlist_created_at?: string
}

export interface IGetFavoritesActivityChild {
  users: TFavoritesActivityChild[]
}

export interface TFavoritesActivityMessage {
  message: string
}

export interface TFavoritesActivityState {
  loading: boolean
  data: TFavoritesActivity[] | null
  errors?: string | undefined
  childData: Map<number, TFavoritesActivityChild[]> | null
}

export enum ActionTypes {
  GET_FAVORITES_ACTIVITY_R = '@@TENDERS/GET_FAVORITES_ACTIVITY_R',
  GET_FAVORITES_ACTIVITY_S = '@@TENDERS/GET_FAVORITES_ACTIVITY_S',
  GET_FAVORITES_ACTIVITY_WITH_O_OFFSET_S = '@@TENDERS/GET_FAVORITES_ACTIVITY_WITH_O_OFFSET_S',
  GET_FAVORITES_ACTIVITY_E = '@@TENDERS/GET_FAVORITES_ACTIVITY_E',

  GET_FAVORITES_ACTIVITY_CHILD_R = '@@TENDERS/GET_FAVORITES_ACTIVITY_CHILD_R',
  GET_FAVORITES_ACTIVITY_CHILD_S = '@@TENDERS/GET_FAVORITES_ACTIVITY_CHILD_S',
  GET_FAVORITES_ACTIVITY_CHILD_E = '@@TENDERS/GET_FAVORITES_ACTIVITY_CHILD_E',
}
